import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Lock from '@/assets/mail.svg';
import { Button } from '@/components/Elements';
import { defaultModalStyles } from '@/components/Elements/Modal/customStyles';

import { PaymentsModal } from '../PaymentsModal';

export type ActivationNeededModalProps = {
  customImage?: string;
  customImageWidth?: string;
  isOpen?: boolean;
  onRequestClose: () => void;
};

export const ActivationNeededModal = ({
  customImage,
  customImageWidth = '150',
  onRequestClose,
  isOpen = false,
}: ActivationNeededModalProps) => {
  const { t } = useTranslation();

  const onActionButton = () => {
    closeModal();
  };

  const closeModal = () => {
    onRequestClose && onRequestClose();
  };

  return (
    <PaymentsModal isOpen={isOpen} style={defaultModalStyles} onRequestClose={closeModal}>
      <h2 className="md__payments__modal__title--h2">{t('ActivationNeededModal.title')}</h2>
      <img
        width={customImageWidth}
        src={customImage || Lock}
        alt={t('ActivationNeededModal.securityNotice')}
        className="mb-7 m-auto"
      />
      <h3 className="md__payments__modal--h3">{t('ActivationNeededModal.description')}</h3>
      <h4 className="md__payments__modal--h4">{t('ActivationNeededModal.notice')}</h4>
      <Button
        className="m-auto mt-10 py-2 lg:py-4 text-xs lg:text-sm w-[300px] rounded-full"
        variant="primary"
        size="free"
        type="button"
        title={t('ActivationNeededModal.actionButton')}
        onClick={onActionButton}
      >
        {t('ActivationNeededModal.actionButton')}
      </Button>
    </PaymentsModal>
  );
};
